import React from 'react';
import c from 'classnames';

import { SearchForumCategories } from '../../../../components';

import './style.scss';

export interface ForumSearchCategoriesProps {
  className?: string;
}

const ForumSearchCategories: React.FC<ForumSearchCategoriesProps> = (props) => {
  const { className } = props;

  const classNames = c('ViewForumSearchCategories', className);

  return (
    <div className={classNames}>
      <SearchForumCategories>
        <SearchForumCategories.Results />
        <SearchForumCategories.Pagination className="mt-4" />
      </SearchForumCategories>
    </div>
  );
};

export default ForumSearchCategories;
